module.exports = __webpack_public_path__ + "static/media/room-out.54e6905b.svg";